import api from '@/api/contents';

const apiLevel = 1;

const resetAllExpressions = (context, data) => {
  context.commit('RESET_ALL_EXPRESSION', data);
};

const getIslandProgression = (context) => {
  api
    .fetchIslandProgression(apiLevel)
    .then((response) => {
      context.commit('GET_ISLAND_PROGRESSION', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
    });
};

const getThematics = (context, thematicId) =>
  new Promise((resolve, reject) => {
    api
      .fetchThematics(apiLevel, thematicId)
      .then((response) => {
        context.commit('GET_THEMATICS', response);
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getThematicsByLevel = (context, data) =>
  new Promise((resolve, reject) => {
    api
      .fetchThematicsByLevel(data)
      .then((response) => {
        if (!data.fetchOnly) {
          context.commit('GET_THEMATICS_BY_LEVEL', response);
        }
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getLesson = (context, lessonId) =>
  new Promise((resolve, reject) => {
    api
      .fetchLesson(apiLevel, lessonId)
      .then((response) => {
        context.commit('GET_LESSON', response);
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const setTeachbotLesson = (context, lesson) =>
  new Promise((resolve) => {
    context.commit('SET_TEACHBOT_LESSON', lesson);
    resolve(lesson);
  });

const getLessonWithoutCommit = (context, lessonId) =>
  new Promise((resolve, reject) => {
    api
      .fetchLesson(apiLevel, lessonId)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getExpressionLesson = (context, params) =>
  new Promise((resolve, reject) => {
    api
      .fetchExpressionLesson(apiLevel, params)
      .then((response) => {
        context.commit('GET_LESSON', response);
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getPlacementLesson = context =>
  new Promise((resolve, reject) => {
    api
      .fetchPlacementLesson(apiLevel)
      .then((response) => {
        context.commit('GET_LESSON', response);
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getLevelUpLesson = (context, level) =>
  new Promise((resolve, reject) => {
    api
      .fetchLevelUpLesson(apiLevel, level)
      .then((response) => {
        context.commit('GET_LESSON', response);
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getCatalog = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .fetchCatalog(apiLevel, payload)
      .then((response) => {
        context.commit('GET_CATALOG', response);
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getLessonInfo = (context, data) => {
  api
    .fetchLessonInfo(apiLevel, data)
    .then((response) => {
      context.commit('GET_LESSON_INFO', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
    });
};

const clearLessonInfo = (context) => {
  context.commit('GET_LESSON_INFO', {});
};

const getExpression = (context, expressionId) =>
  new Promise((resolve, reject) => {
    api
      .fetchExpression(apiLevel, expressionId)
      .then((response) => {
        context.commit('GET_EXPRESSION', response);
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getExpressions = (context, id) => {
  api
    .fetchExpressions(apiLevel, id)
    .then((response) => {
      context.commit('GET_EXPRESSIONS', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
    });
};

const getExpressionsAll = (context, criteria) =>
  new Promise((resolve, reject) => {
    api
      .fetchExpressionsAll(apiLevel, criteria)
      .then((response) => {
        context.commit('GET_EXPRESSIONS_ALL', {
          response,
          category: criteria.category,
        });
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getExpressionTags = context =>
  new Promise((resolve, reject) => {
    api
      .fetchExpressionTags(apiLevel)
      .then((response) => {
        context.commit('GET_EXPRESSION_TAGS', response);
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getWeeklyEnglishLessons = (context, pageSize) =>
  new Promise((resolve, reject) => {
    api
      .fetchWeeklyEnglishLessons(apiLevel, pageSize)
      .then((response) => {
        context.commit('GET_WEEKLY_ENGLISH_LESSONS', response);
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getEvaluatedLesson = (context, data) =>
  new Promise((resolve, reject) => {
    api
      .evaulateLesson(apiLevel, data)
      .then((response) => {
        context.commit('GET_EVALUATE_LESSON', response);
        if (response.user) {
          context.commit('users/SET_PROFILE_USER', response.user, {
            root: true,
          });
        }
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getCurrentlyLoadedIsland = (context, islandData) => {
  context.commit('CURRENTLY_LOADED_ISLAND', islandData);
};

const getTranslatedText = (context, text) =>
  new Promise((resolve, reject) => {
    api
      .translateText(text)
      .then((response) => {
        context.commit(
          'GET_TRANSLATED_TEXT',
          response.data.translations[0].translatedText,
        );
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getTranscribedText = (context, data) => {
  api
    .transcribe(data)
    .then((response) => {
      context.commit(
        'GET_TRANSCRIBED_TEXT',
        response._text,
      ); /* eslint-disable-line */
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
    });
};

const getTeachBotResponse = (context, msg) =>
  new Promise((resolve, reject) => {
    api
      .sendMessageToBot(msg)
      .then((response) => {
        if (msg.chatBotPartner === 'xeropan_landing_page') {
          context.commit('GET_BOT_RESPONSE', response);
        } else {
          context.commit('GET_BOT_RESPONSE', response.data);
        }
        resolve(response.data);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getTeachbotSkeletonResponse = context =>
  new Promise((resolve, reject) => {
    api
      .fetchTeachbotSkeleton(apiLevel)
      .then((response) => {
        context.commit('GET_TEACHBOT_GROUPS_SKELETON_RESPONSE', response);
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getTeachbotResponse = (context, level) =>
  new Promise((resolve, reject) => {
    api
      .fetchTeachbot(apiLevel, level)
      .then((response) => {
        context.commit('GET_TEACHBOT_GROUPS_RESPONSE', response);
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getGrammarSkeletonResponse = context =>
  new Promise((resolve, reject) => {
    api
      .fetchGrammarSkeleton(apiLevel)
      .then((response) => {
        context.commit('GET_GRAMMAR_GROUPS_SKELETON_RESPONSE', response);
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getGrammarResponse = (context, level) =>
  new Promise((resolve, reject) => {
    api
      .fetchGrammar(apiLevel, level)
      .then((response) => {
        context.commit('GET_GRAMMAR_GROUPS_RESPONSE', response);
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const getGrammarsByIds = (context, ids) =>
  new Promise((resolve, reject) => {
    api
      .loadGrammarsByIds(apiLevel, ids)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const favouriteExpression = (context, expressionId) =>
  new Promise((resolve, reject) => {
    api
      .favouriteExpression(apiLevel, { id: expressionId })
      .then((response) => {
        context.commit('SET_FAVOURITE_EXPRESSION_IDS', response);
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const openIsland = (context, islandLevel) =>
  new Promise((resolve, reject) => {
    api
      .openIsland(apiLevel, islandLevel)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const clearGrammarGroups = (context) => {
  context.commit('CLEAR_GRAMMAR_GROUPS');
};

const fetchTextToSpeech = (context, data) =>
  new Promise((resolve, reject) => {
    api
      .fetchTextToSpeech(data)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });

const fetchAllExpressions = (context, learnedLanguage) =>
  new Promise((resolve, reject) => {
    const language = learnedLanguage || 'en';
    api
      .fetchAllExpressions(apiLevel, language)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const fetchAllLessonsByLessonIds = (context, lessons) =>
  new Promise((resolve, reject) => {
    // const body = {
    //   lesson_ids: lessons,
    // };
    api
      .fetchAllLessonsByLessonIds(apiLevel, lessons)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const getClasroomLeaderboardByClassCode = (context, classCode) =>
  new Promise((resolve, reject) => {
    api
      .getClasroomLeaderboardByClassCode(apiLevel, classCode)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const setLanguageCollision = (context, value) =>
  new Promise((resolve) => {
    context.commit('SET_LANGUAGE_COLLISION', value);
    resolve();
  });

const setSendedLanguageCollisonHeader = (context, value) => {
  context.commit('SET_IS_SENDED_LANGUAGE_COLLISON_HEADER', value);
};

const setIsClassLanguageCollison = (context, value) => {
  context.commit('SET_IS_CLASS_LANGUAGE_COLLISON', value);
};

export default {
  resetAllExpressions,
  getIslandProgression,
  getThematics,
  getThematicsByLevel,
  getLesson,
  getLessonWithoutCommit,
  getExpressionLesson,
  getLessonInfo,
  clearLessonInfo,
  getCatalog,
  getEvaluatedLesson,
  getExpression,
  getExpressions,
  getExpressionsAll,
  getExpressionTags,
  getWeeklyEnglishLessons,
  getCurrentlyLoadedIsland,
  getTranslatedText,
  getTranscribedText,
  getTeachBotResponse,
  getTeachbotSkeletonResponse,
  getTeachbotResponse,
  getGrammarSkeletonResponse,
  getGrammarResponse,
  favouriteExpression,
  getPlacementLesson,
  getLevelUpLesson,
  openIsland,
  clearGrammarGroups,
  getGrammarsByIds,
  fetchTextToSpeech,
  fetchAllExpressions,
  fetchAllLessonsByLessonIds,
  getClasroomLeaderboardByClassCode,
  setTeachbotLesson,
  setLanguageCollision,
  setSendedLanguageCollisonHeader,
  setIsClassLanguageCollison,
};
